"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportingLogger = exports.LineItemsLogger = exports.ProductsLogger = exports.QuotesLogger = exports.ListsLogger = exports.SettingsLogger = exports.CommunicatorLogger = exports.CallingLogger = exports.CrmLogger = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _includeScreen = require("./includeScreen");

var _include3ColumnRecordGate = require("./include3ColumnRecordGate");

var _eventNames = _interopRequireDefault(require("./constants/eventNames"));

var _requiredData = _interopRequireDefault(require("./constants/requiredData"));

var _tracker = require("./tracker");

var _namespaces = require("./constants/namespaces");

var _objectTypeFromUrl = require("./utils/objectTypeFromUrl");

var validNamespaces = [_namespaces.CRM, _namespaces.CALLING, _namespaces.SETTINGS, _namespaces.LISTS, _namespaces.QUOTES, _namespaces.PRODUCTS, _namespaces.LINEITEMS, _namespaces.COMMUNICATOR, _namespaces.REPORTING];
var UsageLogger = {
  init: function init(data) {
    UsageLogger.externalData = data;

    _tracker.UsageTracker.init(data);
  },
  logImmediate: function logImmediate(eventName) {
    var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var trackerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      namespace: _namespaces.CRM
    };
    return UsageLogger.log(eventName, eventProps, Object.assign({}, trackerOptions, {
      sendImmediate: true
    }));
  },
  log: function log(eventName) {
    var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var trackerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      sendImmediate: false,
      namespace: _namespaces.CRM
    };

    if (validNamespaces.indexOf(trackerOptions.namespace) === -1) {
      if (_enviro.default.get() !== 'production') {
        console.warn("[UsageLogger]: " + trackerOptions.namespace + " is not a valid namespace. Event will not be logged");
      }
    } else {
      UsageLogger._log(eventName, eventProps, trackerOptions);
    }
  },
  _log: function _log() {
    var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var trackerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      sendImmediate: false,
      namespace: _namespaces.CRM
    };

    // some dynamic call sites are hard to migrate off of where_app_override
    // right now so this hydrates the namespace to make sure events go to the
    // right place
    if (eventProps.where_app_override && trackerOptions.namespace === 'crm') {
      trackerOptions.namespace = eventProps.where_app_override;
    }

    _tracker.UsageTracker.track(eventName, eventProps, trackerOptions);
  },
  logEventAndProps: function logEventAndProps(properties) {
    var newProps = (0, _includeScreen.includeScreen)(properties);

    if (newProps) {
      var event = newProps.event,
          eventProps = newProps.eventProps;

      UsageLogger._log(event, eventProps, properties.options);
    }
  },
  // New Logging Methods
  // Refer to: https://git.hubteam.com/HubSpot/CRM/issues/6661
  logSettingsInteraction: function logSettingsInteraction(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.SETTINGS_INTERACTION,
      objectType: objectType,
      eventProps: eventProps,
      options: {
        namespace: _namespaces.SETTINGS
      }
    });
  },
  logRecordInteraction: function logRecordInteraction(objectType, eventProps) {
    var eventData = {
      event: _eventNames.default.RECORD_INTERACTION,
      objectType: objectType,
      eventProps: eventProps
    };

    if (UsageLogger.externalData && UsageLogger.externalData[_requiredData.default.OPTED_INTO_3_COLUMN]) {
      UsageLogger.externalData[_requiredData.default.OPTED_INTO_3_COLUMN]().then(function (optedIn) {
        return (0, _include3ColumnRecordGate.include3ColumnRecordGate)(eventData, optedIn);
      }).then(UsageLogger.logEventAndProps);
    } else {
      UsageLogger.logEventAndProps(eventData);
    }
  },
  logIndexInteraction: function logIndexInteraction(objectType, eventProps, options) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.INDEX_INTERACTION,
      objectType: objectType,
      eventProps: eventProps,
      options: options
    });
  },
  logInternal: function logInternal(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.INTERNAL_CRM_TRACKING,
      objectType: objectType,
      eventProps: eventProps
    });
  },
  logCRMOnboarding: function logCRMOnboarding(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.CRM_ONBOARDING,
      objectType: objectType,
      eventProps: eventProps
    });
  },
  logError: function logError(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.CRM_API_ERROR,
      objectType: objectType,
      eventProps: eventProps
    });
  },
  logDebug: function logDebug(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.CRM_DEBUG,
      objectType: objectType,
      eventProps: eventProps
    });
  },
  logForBizOps: function logForBizOps(objectType, eventProps) {
    return UsageLogger.logEventAndProps({
      event: _eventNames.default.BIZOPS_INTERACTION,
      objectType: objectType,
      eventProps: eventProps
    });
  },
  forNewPortals: function forNewPortals(logger, objectType, eventProps) {
    if (UsageLogger.externalData && UsageLogger.externalData[_requiredData.default.PORTAL_AGE_DAYS]) {
      UsageLogger.externalData[_requiredData.default.PORTAL_AGE_DAYS]().then(function (age) {
        var isNewPortal = age < 1;

        var isDebugging = _enviro.default.debug('firstDayLogging');

        if (isDebugging || isNewPortal) {
          logger(objectType, eventProps);
        }
      });
    }
  }
};
exports.CrmLogger = UsageLogger;
var CallingLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.CALLING
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.CALLING
    });
  }
};
exports.CallingLogger = CallingLogger;
var CommunicatorLogger = {
  log: function log(eventName) {
    var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!eventProps.hasOwnProperty('screen')) {
      eventProps.screen = (0, _objectTypeFromUrl.objectTypeFromUrl)();
    }

    UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.COMMUNICATOR
    });
  },
  logImmediate: function logImmediate(eventName) {
    var eventProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    eventProps.screen = (0, _objectTypeFromUrl.objectTypeFromUrl)();
    UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.COMMUNICATOR
    });
  }
};
exports.CommunicatorLogger = CommunicatorLogger;
var SettingsLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.SETTINGS
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.SETTINGS
    });
  }
};
exports.SettingsLogger = SettingsLogger;
var ListsLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.LISTS
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.LISTS
    });
  }
};
exports.ListsLogger = ListsLogger;
var QuotesLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.QUOTES
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.QUOTES
    });
  }
};
exports.QuotesLogger = QuotesLogger;
var ProductsLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.PRODUCTS
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.PRODUCTS
    });
  }
};
exports.ProductsLogger = ProductsLogger;
var LineItemsLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.LINEITEMS
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.LINEITEMS
    });
  }
};
exports.LineItemsLogger = LineItemsLogger;
var ReportingLogger = {
  log: function log(eventName, eventProps) {
    return UsageLogger.log(eventName, eventProps, {
      namespace: _namespaces.REPORTING
    });
  },
  logImmediate: function logImmediate(eventName, eventProps) {
    return UsageLogger.logImmediate(eventName, eventProps, {
      namespace: _namespaces.REPORTING
    });
  }
};
exports.ReportingLogger = ReportingLogger;